import * as _ from 'lodash';

export const columns: any = [
  {
    title: 'select-all-btn',
    colSize: '5',
    active: false,
    col: 'select-btn'
  },
  {
    title: 'Column options',
    colSize: '30',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'title',
  }
];
